import type { SlaState } from "../../domain/workOrderReport";

/** The colour an SLA state is drawn in; always beside its label, never instead of it. */
export const SLA_TONE: Record<SlaState, string> = {
  breached: "var(--red)",
  missed: "var(--red)",
  at_risk: "var(--amber)",
  on_track: "var(--green)",
  met: "var(--green)",
  none: "var(--dim)",
  void: "var(--dim)",
};
